module.exports = __webpack_public_path__ + "static/media/retina_v2.84632eb1.jpg";